import React, { useEffect } from 'react';
import { Button } from '@/components/ui/button';
import { Link } from '@/components/common/Link';
declare global {
  interface Window {
    Calendly: {
      initPopupWidget: (options: {
        url: string;
      }) => void;
    };
  }
}
export default function Hero() {
  useEffect(() => {
    const link = document.createElement('link');
    link.href = 'https://assets.calendly.com/assets/external/widget.css';
    link.rel = 'stylesheet';
    document.head.appendChild(link);
    const script = document.createElement('script');
    script.src = 'https://assets.calendly.com/assets/external/widget.js';
    script.async = true;
    document.head.appendChild(script);
    return () => {
      const existingScript = document.querySelector('script[src="https://assets.calendly.com/assets/external/widget.js"]');
      if (existingScript) {
        existingScript.remove();
      }
      const existingLink = document.querySelector('link[href="https://assets.calendly.com/assets/external/widget.css"]');
      if (existingLink) {
        existingLink.remove();
      }
    };
  }, []);
  const handleScheduleConsultation = () => {
    if (window.Calendly) {
      window.Calendly.initPopupWidget({
        url: 'https://calendly.com/mfloresdo/30min'
      });
    }
    return false;
  };
  return <section className="relative w-full min-h-[650px] md:min-h-screen lg:min-h-[700px]">
      <div className="absolute inset-0 bg-white bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1375869/img/fit_man_late_thirties_confident_pose.png)] bg-cover bg-no-repeat bg-center">
        <div className="absolute inset-0 bg-primary-dark-bg/70"></div>
        <div className="relative h-full min-h-[650px] md:min-h-[650px] lg:min-h-[700px] flex items-center justify-center py-12 sm:py-12 md:py-24 px-4">
          <div className="container text-center">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-semibold text-white leading-tight mb-3 md:mb-6">
              Feel Like Yourself Again — Full of Energy, Strength, and Confidence
            </h1>
            <p className="text-xl md:text-2xl text-white font-medium leading-snug mb-4 md:mb-6 max-w-3xl mx-auto">For men tired of low energy, stubborn fat, and frustration with solutions that don't last.</p>
            <p className="text-lg md:text-xl text-white/90 leading-relaxed mb-8 md:mb-12 max-w-3xl mx-auto">
              Not just hormone numbers. <strong>We help men reclaim their physique, restore consistent energy and feel ready for life again — without guesswork.</strong> Serving all of Texas through telemedicine.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Button onClick={handleScheduleConsultation} className="bg-gradient-to-r from-accent to-accent-hover text-accent-foreground hover:from-accent-hover hover:to-accent-active px-8 py-4 h-12 text-base font-bold rounded-sm shadow-strong hover:shadow-xl hover:-translate-y-1 transform transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] ring-2 ring-accent/20 hover:ring-accent/40 hover:scale-105">Start Your Energy & Performance Reset</Button>
              <Button asChild className="bg-primary text-primary-foreground hover:bg-primary-hover px-8 py-4 h-12 text-base font-semibold rounded-sm shadow-medium hover:shadow-strong hover:-translate-y-0.5 transform transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] border border-primary-light-bg/20">
                
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>;
}